// extracted by mini-css-extract-plugin
export default {"fontStyrene":"aOZYNI","externalFont":"bOZYNI"};